
const { ccclass, property, menu } = cc._decorator;

@ccclass
export default class BiPaiCardTypeAnimHolder extends cc.Component{

   @property(cc.Node)
   nodeAnim: cc.Node = null

   protected dragBones: dragonBones.ArmatureDisplay = null

   protected playAnim(show: boolean, name: string, onFinish?: Function){
      let self = this
      self.ensureInitedDragbones()
      self.dragBones.node.active = !!show
      self.dragBones.playAnimation(name, 1)
      if(show){
         self.scheduleOnce(function(){ 
            onFinish && onFinish()
         }, 3)
      }else{
         onFinish && onFinish()
      }
   }

   playSanTiaoAnim(show: boolean, onFinish?: Function){
      this.playAnim(show, '三条', onFinish)
   }

   playSiTiaoAnim(show: boolean, onFinish?: Function){
      this.playAnim(show, '四条', onFinish)  
   }

   playTongHuaAnim(show: boolean, onFinish?: Function){
      this.playAnim(show, '同花', onFinish)   
   }

   playTongHuaShunAnim(show: boolean, onFinish?: Function){
      this.playAnim(show, '同花顺', onFinish)
   }

   playHuangJiaTongHuaShunAnim(show: boolean, onFinish?: Function){
      this.playAnim(show, '皇家同花顺', onFinish)
   }

   playShunZiAnim(show: boolean, onFinish?: Function){
      this.playAnim(show, '顺子', onFinish)
   }

   playHuLuAnim(show: boolean, onFinish?: Function){
      this.playAnim(show, '葫芦', onFinish)
   }

   playZiMoAnim(show: boolean, onFinish?: Function){
      this.playAnim(show, '自摸', onFinish)
   }

   playJiePaoAnim(show: boolean, onFinish?: Function){
      this.playAnim(show, '接炮', onFinish)
   }

   protected ensureInitedDragbones(){
      if(this.dragBones){
         return
      }
      let node = cc.instantiate(this.nodeAnim)
      node.parent = this.node
      node.position = cc.Vec2.ZERO
      this.dragBones = node.getComponent(dragonBones.ArmatureDisplay)
   }

}
